<template lang="pug">
bottom-modal(:id="modalId", width="w-xtra-large", :loading="onLoading('save-product')")
    span(slot="header-text") {{ product !== null && productExists ? 'Update' : 'Create' }} Product
    div(slot="body")
        div.container
            form(id="product-form", @submit.prevent="submit", v-if="product != null")
                fieldset(:disabled="onLoading('save-product')")
                    div.row
                        div.col-md-6.p-l-md.p-t-md.p-r-md
                            h6.m-b-md Details

                            div.row
                                div.col-xs-5.col-sm-4
                                    div.box
                                        dropzone(
                                            v-show="product.media_urls.length == 0",
                                            ref="dropzone",
                                            id="itemImage",
                                            paramName="media",
                                            :url="api_media",
                                            :acceptedFileTypes="'image/*'",
                                            :maxNumberOfFiles="1",
                                            v-on:vdropzone-sending="onSendingFile",
                                            v-on:vdropzone-success="onUploadSuccess",
                                            :autoProcessQueue="false"
                                        )

                                        div.dz-custom-image-preview(
                                            v-if="product.media_urls.length > 0"
                                        )
                                            img(
                                                :src="product.media_urls[0].original",
                                                alt="Product image"
                                            )
                                            span.remove-icon(
                                                @click="removeImage"
                                            )
                                div.col-xs-7.col-sm-8
                                    div.md-form-group
                                        input.md-input(
                                            type="text",
                                            v-model="product.code"
                                        )
                                        label Code

                                    div.md-form-group
                                        input.md-input(
                                            type="text",
                                            v-model="product.name",
                                            placeholder="Required"
                                            required
                                        )
                                        label Name

                            div.row
                                div.col-xs-12
                                    div.md-form-group
                                        select.md-input(
                                            v-model="product.price_type"
                                            @change="isTypeFixed && !hasVariant ? addVariant() : ''",
                                        )
                                            option(
                                                v-for="pricing in pricingType",
                                                v-bind:value="pricing.id"
                                            ) {{ pricing.name }}
                                        label Pricing

                            div.row(v-show="isTypeUnitPrice")
                                div.col-xs-6
                                    div.md-form-group(:class="{'invalid': hasUnitPriceError()}")
                                        input.md-input(
                                            type="text",
                                            v-model="product.unit_price",
                                            data-parsley-type="number",
                                            data-parsley-min="0",
                                            data-parsley-min-message="This value should be greater than or equal to 0.",
                                            data-parsley-errors-messages-disabled="",
                                            min="0",
                                            required,
                                            @input="validateUnitPrice($event.target.value)",
                                            :class="{'parsley-error': hasUnitPriceError()}"
                                        )
                                        label(:class="{'text-danger': hasUnitPriceError()}") Unit Price
                                        ul.parsley-errors-list(v-if="hasUnitPriceError()")
                                            li.text-danger {{ getUnitPriceErrorMessage() }}

                                div.col-xs-6
                                    div.md-form-group(:class="{'invalid': hasCostError()}")
                                        input.md-input(
                                            type="text",
                                            v-model="product.cost",
                                            data-parsley-type="number",
                                            data-parsley-min="0",
                                            data-parsley-min-message="This value should be greater than or equal to 0.",
                                            data-parsley-errors-messages-disabled="",
                                            min="0",
                                            @input="validateCost($event.target.value)",
                                            :class="{'parsley-error': hasCostError()}"
                                        )
                                        label(:class="{'text-danger': hasCostError()}") Cost
                                        ul.parsley-errors-list(v-if="hasCostError()")
                                            li.text-danger {{ getCostErrorMessage() }}

                            product-variants(
                                :product="product",
                                v-show="isTypeFixed",
                                ref="productVariant"
                            )

                        div.col-md-6.p-a-md
                            h6.m-b-md Options

                            div.row
                                div.col-xs-12
                                    div.md-form-group(v-if="! productExists")
                                        select.md-input(
                                            v-model="product.outlet_id",
                                            :disabled="productExists"
                                        )
                                            option(
                                                v-if="canAccessAllOutlets"
                                                :value="0"
                                            ) Apply to all outlet
                                            option(
                                                v-for="outlet in outletList",
                                                v-bind:value="outlet.id"
                                            ) {{ outlet.name }}
                                        label Outlet
                                    div.m-b-sm(v-else)
                                        span.clear.text-muted Outlet
                                        | {{ productOutlet ? productOutlet : 'Visible to all outlet' }}

                            div.row
                                div.col-xs-12
                                    div.form-group
                                        category-selector(v-model="product.category")

                            div.row
                                div.col-xs-12
                                    div.form-group
                                        tag-selector(v-model="product.tags")

                            div.row
                                div.col-xs-12
                                    div.form-group
                                        modifier-selector(
                                            v-model="product.modifier_sets"
                                            :tag-modifiers="fixedModifiers"
                                        )

                            div.row
                                div.col-xs-12
                                    div.form-group
                                        label.typo__label.multiselect-label Taxes
                                        multiselect(
                                            v-model="product.taxes",
                                            label="tax_disc",
                                            track-by="id",
                                            placeholder="Type to search",
                                            :options="taxList",
                                            :multiple="false",
                                            :close-on-select="true",
                                            :hide-selected="false",
                                            :max-height="170",
                                            :limit="5"
                                        )

                            div.row
                                div.col-xs-12.p-t-sm
                                    div.md-form-group
                                        textarea(
                                            rows="2",
                                            class="md-input",
                                            v-model="product.description"
                                        )
                                        label Description

                            div.row
                                div.col-xs-12
                                    label Options
                                    div.form-group
                                        p
                                            label.md-switch
                                                input(
                                                    v-model="status"
                                                    type="checkbox"
                                                )
                                                i.indigo
                                                | Hide product
                                        p
                                            small The product will be hidden from Central and Waiter

                                    .form-group
                                        p
                                            label.md-switch
                                                input(
                                                    v-model="product.chargeable"
                                                    type="checkbox"
                                                )
                                                i.indigo
                                                | Apply charges
                                        p
                                            small Applicable charges will be applied to the product during checkout

                            div.row
                                div.col-xs-12
                                    div.form-group
                                        label Central Display Options
                                        br
                                        color_picker(
                                            :color="product.color_code",
                                            id="_colorpicker",
                                            ref="colorPicker"
                                        )


    button.btn.btn-fw.primary(
        slot="footer",
        @click="submit()",
        :disabled="onLoading('save-product') || !canManageItems || readOnlyItems"
    )
        v-loading(loader="save-product") Save

    label.md-switch(slot="popup" v-if="!productExists")
        input(type='checkbox', v-model="toggle")
        i.indigo
        | Keep form open

</template>

<script>
import AuthMixin from '@js/mixins/auth';
import modifierSelector from './modifier-selector.vue';
import tagSelector from './tag-selector.vue';
import categorySelector from './category-selector.vue';
import productVariants from './product-variants.vue';
import PermissionMixin from '../item-permission';
import { mapGetters, mapActions } from 'vuex';

const pricingType = [
    { name: 'Variants', id: 0 },
    { name: 'Unit', id: 1 },
    { name: 'Variable', id: 2 },
];

export default {
    components: {
        modifierSelector,
        tagSelector,
        productVariants,
        categorySelector,
    },

    mixins: [AuthMixin, PermissionMixin],

    data() {
        return {
            toggle: false,
            mediaId: 0,
            remove_media: false,
            pricingType,
            product: null,
            unitPriceError: false,
            costError: false,
        };
    },

    computed: {
        activeOutlet() {
            let ao = this.$store.getters.activeOutlet;

            if (this.canAccessAllOutlets && ao === 0) {
                return ao;
            }

            if (_.includes(Auth.outlets, ao)) {
                return ao;
            }

            return this.firstAvailableOutlet();
        },

        modalId() {
            return 'item-popup';
        },

        api_media() {
            return Laroute.route('franchise.inventory.item.addmedia');
        },

        ...mapGetters(['activeOutlet', 'outletList', 'findOutletById']),

        ...mapGetters('tax', ['taxList', 'taxAutoAssignProductList']),

        isTypeFixed() {
            return this.product.price_type == 0;
        },

        isTypeUnitPrice() {
            return this.product.price_type == 1;
        },

        productExists() {
            if (this.product) {
                return this.product.id != 0 && this.product.id != undefined;
            }

            return false;
        },

        hasVariant() {
            return this.product.variants.length > 0;
        },

        productOutlet() {
            const outlet = this.findOutletById(this.product.outlet_id);

            if (_.isUndefined(outlet)) {
                return null;
            }

            return outlet.name;
        },

        status: {
            get() {
                return this.product.status == 0;
            },

            set(value) {
                this.product.status = value ? 0 : 1;
            },
        },

        fixedModifiers() {
            let m = [];

            if (this.product) {
                let tags = this.product.tags;
                tags.forEach(t => {
                    if (t.modifier_sets) {
                        t.modifier_sets.forEach(n => m.push(n));
                    }
                });
            }

            return _.uniqBy(m, 'id');
        },
    },

    watch: {
        toggle(data) {
            localStorage.setItem('toggle', data);
        },
    },

    mounted() {
        if (localStorage.getItem('toggle')) {
            this.toggle = JSON.parse(localStorage.getItem('toggle'));
        }
    },

    created() {
        this.getTaxList();
        this.getCategories();
        this.registerEventBus();
    },

    methods: {
        ...mapActions('product', [
            'getProduct',
            'updateProduct',
            'createProduct',
        ]),

        ...mapActions('category', ['getCategories']),

        ...mapActions('tax', ['getTaxList']),

        setProduct(product) {
            this.product = product;
            // Reset errors when product is set
            this.unitPriceError = false;
            this.costError = false;
        },

        submit() {
            // Validate unit price and cost before parsley validation
            if (this.isTypeUnitPrice) {
                this.validateUnitPrice(this.product.unit_price);
                if (this.product.cost !== null && this.product.cost !== '') {
                    this.validateCost(this.product.cost);
                }
            }

            if (this.hasUnitPriceError() || this.hasCostError()) {
                return;
            }

            if (!this.validateForm('product-form')) {
                return;
            }

            if (this.hasRejectedFile()) {
                return;
            }

            this[this.productExists ? 'updateProduct' : 'createProduct'](
                this.mapProductValue(),
            )
                .then(res => {
                    let data = res.data.data;

                    if (this.hasFileToUpload(data.id)) {
                        this.uploadFile(data.id);
                    } else {
                        this.successCallback();
                    }
                })
                .catch(err => {
                    this.showApiError(err);
                });
        },

        addVariant: function() {
            this.$refs.productVariant.addVariant();
        },

        mapProductValue() {
            const product = _.pick(this.product, [
                'id',
                'name',
                'code',
                'price_type',
                'outlet_id',
                'description',
                'unit_price',
                'cost',
                'status',
                'chargeable',
            ]);

            return Object.assign(product, {
                variants: this.getVariants(),
                tags: this.product.tags.map(obj => obj.id),
                modifier_sets: this.product.modifier_sets.map(obj => obj.id),
                color_code: this.$refs.colorPicker.color_code,
                remove_media: this.remove_media,
                taxes: !_.isNull(this.product.taxes)
                    ? this.product.taxes.id
                    : null,
                category_id: !_.isNull(this.product.category)
                    ? this.product.category.id
                    : null,
            });
        },

        getVariants() {
            if (this.isTypeFixed) {
                return this.sortVariantBySequence(this.product.variants, true);
            } else {
                return [];
            }
        },

        sortVariantBySequence(variants, is_submitted = false) {
            let v;

            if (!is_submitted) {
                v = _.sortBy(variants, v => v.sequence);
            } else {
                v = variants;
            }

            v.forEach((v, idx) => {
                this.$set(v, 'sequence', ++idx);
            });

            return v;
        },

        onSendingFile(file, xhr, formData) {
            formData.append('id', this.mediaId);
        },

        onUploadSuccess(file, response) {
            this.successCallback();
            this.$refs.dropzone.removeAllFiles();
        },

        successCallback() {
            this.endLoading('save-product');
            this.showToastrSuccess();
            this.$emit('product-saved');

            if (this.productExists) {
                this.hideModal();
            }

            if (!this.toggle) {
                this.hideModal();
            }
            this.resetForm();
        },

        removeImage() {
            this.product.media_urls = [];
            this.remove_media = true;
        },

        validateUnitPrice(value) {
            if (value === null || value === '') {
                this.unitPriceError = false;
                return;
            }
            const numValue = parseFloat(value);
            // Check if value is a valid number and not negative
            const isValidNumber = !isNaN(numValue) && isFinite(value);
            this.unitPriceError = !isValidNumber || numValue < 0;
        },

        validateCost(value) {
            if (value === null || value === '') {
                this.costError = false;
                return;
            }
            const numValue = parseFloat(value);
            // Check if value is a valid number and not negative
            const isValidNumber = !isNaN(numValue) && isFinite(value);
            this.costError = !isValidNumber || numValue < 0;
        },

        hasUnitPriceError() {
            return this.unitPriceError;
        },

        hasCostError() {
            return this.costError;
        },

        getUnitPriceErrorMessage() {
            if (!this.product.unit_price || this.product.unit_price === '') {
                return 'This value should be greater than or equal to 0.';
            }
            const numValue = parseFloat(this.product.unit_price);
            if (isNaN(numValue) || !isFinite(this.product.unit_price)) {
                return 'Please enter a valid number.';
            }
            return 'This value should be greater than or equal to 0.';
        },

        getCostErrorMessage() {
            if (!this.product.cost || this.product.cost === '') {
                return 'This value should be greater than or equal to 0.';
            }
            const numValue = parseFloat(this.product.cost);
            if (isNaN(numValue) || !isFinite(this.product.cost)) {
                return 'Please enter a valid number.';
            }
            return 'This value should be greater than or equal to 0.';
        },

        resetForm() {
            this.unitPriceError = false;
            this.costError = false;
            this.$refs.dropzone.removeAllFiles();
            this.remove_media = false;
            this.setProduct(this.attributes());
        },

        hasFileToUpload(id) {
            let files = this.$refs.dropzone.getAcceptedFiles();
            return (
                !_.isEmpty(files) && !_.isUndefined(id) && files[0].name != ''
            );
        },

        hasRejectedFile() {
            return this.$refs.dropzone.getRejectedFiles().length > 0;
        },

        uploadFile(productId) {
            this.mediaId = productId;
            this.$refs.dropzone.processQueue();
        },

        showModal() {
            $(`#${this.modalId}`).modal('show');
        },

        hideModal() {
            $(`#${this.modalId}`).modal('hide');
        },

        registerEventBus() {
            this.$on('show-form', product => {
                if (this.product !== null) {
                    this.resetForm();
                }

                if (product === null) {
                    this.setProduct(this.attributes());
                    this.showModal();
                } else {
                    if (this.onLoading('fetch-product')) {
                        return;
                    }

                    this.getProduct(product.id)
                        .then(res => {
                            const product = res.data.data;

                            if (product.variants.length) {
                                const sortedVariants = this.sortVariantBySequence(
                                    product.variants,
                                );
                                product.variants = sortedVariants;
                            }

                            this.setProduct(product);
                            this.showModal();
                        })
                        .catch(err => this.showApiError(err));
                }
            });
        },

        attributes() {
            return {
                code: '',
                name: '',
                outlet_id: this.activeOutlet
                    ? this.activeOutlet
                    : this.firstAvailableOutlet,
                description: '',
                variants: [
                    {
                        id: null,
                        code: null,
                        name: 'Regular',
                        cost: '0.00',
                        price: '0.00',
                        default: true,
                        sequence: 1,
                    },
                ],
                price_type: 1,
                color_code: null,
                modifier_sets: [],
                tags: [],
                category: null,
                taxes: this.taxAutoAssignProductList,
                unit_price: '0.00',
                cost: null,
                media_urls: [],
                status: 1,
                chargeable: true,
            };
        },
    },
};
</script>



// WEBPACK FOOTER //
// resources/assets/js/franchise_component/inventory/item/vuetableitem_form.vue